
/* eslint-disable complexity */
import { init } from '../google'

/**
 * Binds a AddressGeocoder hook to an element.
 *
 * @param {HTMLElement} element The Location element
 * @param {LiveHook} instance The LiveHook instance to interact with the server-side state
 * @param {Object} opts The options to configure the autocomplete results
 *
 * @returns {void}
 */

function fillInAddress(element, result) {
  const address = element.getAttribute('data-address')
  const streetAddressLineOne = document.querySelector(`[data-address="${address}"][data-address-field="address_line_one"]`) || {}
  const streetAddressLineTwo = document.querySelector(`[data-address="${address}"][data-address-field="address_line_two"]`) || {}
  const city = document.querySelector(`[data-address="${address}"][data-address-field="address_city"]`) || {}
  const state = document.querySelector(`[data-address="${address}"][data-address-field="address_state"]`) || {}
  const zipCode = document.querySelector(`[data-address="${address}"][data-address-field="address_zip_code"]`) || {}

  let address1 = ''

  let postcode = ''

  // Get each component of the address from the place details,
  // and then fill-in the corresponding field on the form.
  // place.address_components are google.maps.GeocoderAddressComponent objects
  // which are documented at http://goo.gle/3l5i5Mr
  for (const component of result.address_components) {
    const componentType = component.types[0];

    switch (componentType) {
    case 'street_number': {
      address1 = `${component.long_name} ${address1}`;
      break;
    }

    case 'route': {
      address1 += component.short_name;
      break;
    }

    case 'postal_code': {
      postcode = `${component.long_name}${postcode}`;
      break;
    }

    case 'locality': {
      city.value = component.long_name;
      break;
    }

    case 'administrative_area_level_1': {
      state.value = component.long_name;
      break;
    }

    default: {
      break;
    }
    }
  }

  streetAddressLineOne.value = address1;
  zipCode.value = postcode;
  // After filling the form with address components from the Autocomplete
  // prediction, set cursor focus on the second address line to encourage
  // entry of subpremise information such as apartment, unit, or floor number.
  streetAddressLineTwo.focus();
}

function bind(element) {
  element.addEventListener('keydown', (event) => {
    if (event.keyCode === 13 || event.key === 'Enter') {
      event.preventDefault()
    }
  })

  init(element, { types: ['geocode'] }, (result) => fillInAddress(element, result))
}

const AddressGeocoder = {
  mounted() {
    bind(this.el, this)
  },
}

export default {
  bind,
  hook: AddressGeocoder,
}
